import Loader from "@components/atoms/Loader";
import {
  ProductListMode,
  ProductSortBy,
} from "@interfaces/components/product-filters.interface";
import { Product } from "@interfaces/dto/products.dto";
import { ReactNode } from "react";
import InfiniteScroll from "react-infinite-scroller";
import Toolbar from "../filters/Toolbar";
import GridItem from "../items/GridItem";
import ListItem from "../items/ListItem";
import {
  DEFAULT_ITEMS_PER_ROW,
  LAYOUT_DEFAULT,
  EXTRA_ITEMS_PER_ROW,
} from "@const/products.const";

interface Props {
  productListMode: ProductListMode;
  onViewModeChange: (mode: ProductListMode) => void;
  products: Product[];
  gridSize?: number;
  isToolbarVisible?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  sortBy: ProductSortBy;
  onSortByChange: (soryBy: ProductSortBy) => void;
  allowLoadMore: boolean;
  pageLayout: string | undefined;
}

const CateProducts = ({
  productListMode,
  onViewModeChange,
  products,
  gridSize = 4,
  isToolbarVisible = true,
  page,
  onPageChange,
  sortBy,
  onSortByChange,
  allowLoadMore,
  pageLayout,
}: Props) => {
  const renderToolBar = () => (
    <Toolbar
      productListMode={productListMode}
      onViewModeChange={onViewModeChange}
      sortBy={sortBy}
      onSortByChange={onSortByChange}
    />
  );

  const renderIfinitScrollGrid = (children: ReactNode) => (
    <InfiniteScroll
      pageStart={1}
      loadMore={onPageChange}
      hasMore={allowLoadMore}
      loader={<Loader key={page} />}
      className={`row ${
        pageLayout === LAYOUT_DEFAULT
          ? DEFAULT_ITEMS_PER_ROW
          : EXTRA_ITEMS_PER_ROW
      }`}
    >
      {children}
    </InfiniteScroll>
  );

  const renderIfinitScrollList = (children: ReactNode) => (
    <InfiniteScroll
      pageStart={1}
      loadMore={onPageChange}
      hasMore={allowLoadMore}
      loader={<Loader key={page} />}
      className="row"
    >
      {children}
    </InfiniteScroll>
  );

  return (
    <>
      {productListMode === "grid" && (
        <div className={`product-list-grid product-col-lg-${gridSize}`}>
          <div className="row">
            <div className="col">{isToolbarVisible && renderToolBar()}</div>
          </div>
          {renderIfinitScrollGrid(
            products.map((product, idx) => (
              <div key={idx} className="col">
                <GridItem product={product} />
              </div>
            ))
          )}
        </div>
      )}
      {productListMode === "list" && (
        <div className="product-list-list">
          <div className="row">
            <div className="col">{isToolbarVisible && renderToolBar()}</div>
          </div>
          {renderIfinitScrollList(
            products.map((product, idx) => (
              <div key={idx} className="col-12">
                <ListItem product={product} />
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
};

export default CateProducts;
